import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {TranscriptionIndicesQuery} from 'molbio/transcriptions/__generated/TranscriptionIndicesQuery';

export type TranscriptionMatches = TranscriptionIndicesQuery['sequence'];

export const TRANSCRIPTION_INDICES_QUERY = gql`
  query TranscriptionIndicesQuery($sequenceId: StrictString!) @skipAudit @engComponent(name: MOLBIO) {
    sequence(id: $sequenceId) {
      ... on SequenceNode {
        id
        transcriptionMatches {
          start
          end
          rnaSequence {
            ... on SequenceNode {
              __typename
              id
              name
              tagSchema {
                id
                iconId
              }
            }
          }
          isReverseComplement
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
